import React, { Component } from 'react'
import { FormattedMessage, FormattedDate, FormattedTime, injectIntl } from "react-intl";
import './questionconversation.scss'
import $ from 'jquery'
import ImageGallery from "../common/image/gallery.component";

class QuestionConversationContent extends Component {

    constructor(props, context) {
        super(props, context)

        let project = this.props.project || null
        let conversationThreads = [
            {
                messages: []
            }
        ]
        if (project && project.attributes) {
            conversationThreads = project.attributes.conversationThreads
        } else if (project && !project.attributes) {
            conversationThreads = project.conversationThreads
        }

        this.state = {
            project,
            conversationThreads,
            selectedThread: this.props.selectedThread || 0,
            isCustomer: this.props.isCustomer || false,
        }
    }

    componentDidMount() {
        this.scrollToBottomOfContent()
    }

    componentWillReceiveProps(nextProps) {
        let previousStateConversationThreads = [...this.state.conversationThreads]
        let conversationThreads = [...this.state.conversationThreads]
        if (nextProps.project && nextProps.project.attributes) {
            conversationThreads = nextProps.project.attributes.conversationThreads
        } else if (nextProps.project && !nextProps.project.attributes) {
            conversationThreads = nextProps.project.conversationThreads
        }

        this.setState({
            project: nextProps.project || null,
            conversationThreads,
            selectedThread: nextProps.selectedThread || 0,
            isCustomer: nextProps.isCustomer || false,
        }, () => {
            if (this.state.selectedThread === -1) {
                return
            }

            const currentThreadLength = this.state.conversationThreads[this.state.selectedThread]?.messages?.length
            const previousThreadLength = previousStateConversationThreads[this.state.selectedThread]?.messages?.length

            if (currentThreadLength && previousThreadLength && currentThreadLength > previousThreadLength) {
                this.scrollToBottomOfContent()
            }
        })
    }
    scrollToBottomOfContent() {
        if (!$("#questionConversationContent")[0] || !$("#questionConversationContent").children().last()[0]) {
            return
        }
        $('#questionConversationContent').parent().animate({
            scrollTop: $("#questionConversationContent")[0].scrollHeight -
                $("#questionConversationContent").children().last()[0].scrollHeight
        }, 500)
    }

    isCurrentUserMessage(messageSendByUserType) {
        if (messageSendByUserType === "seller") {
            return !this.state.isCustomer
        } else if (messageSendByUserType === "customer") {
            return this.state.isCustomer
        }
    }

    conversationThreadExists() {
        return this.state.conversationThreads && this.state.conversationThreads.length > 0 && this.state.selectedThread !== -1 &&
            this.state.conversationThreads[this.state.selectedThread]
    }

    render() {
        return <ul id="questionConversationContent" className="question-conversation-content list-group list-group-flush mb-2 h-100">
            {this.conversationThreadExists() && this.state.conversationThreads[this.state.selectedThread].messages.map((m, index) => {
                return <li key={index}
                    className={'list-group-item border-0 ' + (!this.isCurrentUserMessage(m.attributes.sender) ? 'text-left' : 'text-right')} >

                    {m.attributes.content.length > 0 &&
                        <div className={'d-flex ' + (!this.isCurrentUserMessage(m.attributes.sender) ? 'justify-content-start' : 'justify-content-end')} >
                            <div className="px-3 py-2 rounded text-break text-left"
                                style={{
                                    backgroundColor: (!this.isCurrentUserMessage(m.attributes.sender) ? '#f4f4f4' : 'lightblue'),
                                    width: 'fit-content',
                                    maxWidth: '80%'
                                }}>
                                {m.attributes.content.split('\n').map((v, i) => <p key={i} className={'m-0'}>{v}</p>)}
                            </div>
                        </div>
                    }

                    {m.attributes.images && m.attributes.images.length > 0 &&
                        <div className="px-3 py-2 rounded"
                            style={{
                                backgroundColor: (!this.isCurrentUserMessage(m.attributes.sender) ? '#f4f4f4' : 'lightblue'),
                            }}>
                            <ImageGallery
                                value={m.attributes.images}
                            />
                        </div>
                    }
                    <div>
                        <small><b> {<FormattedDate
                            year='numeric'
                            month='long'
                            day='numeric'
                            value={
                                m.attributes.createdAt
                            } />} <FormattedMessage
                                id="question.conversation.at"
                                defaultMessage="at"
                            /> {<FormattedTime
                                value={m.attributes.createdAt}
                            />}</b></small>
                    </div>
                </li>
            })
            }
            {(this.conversationThreadExists() && this.state.conversationThreads[this.state.selectedThread].messages.length === 0) || (this.state.conversationThreads.length === 0 || this.state.selectedThread === -1) &&
                <li key={2}
                    className={'list-group-item border-0 text-left'} >
                    <div className={'d-flex justify-content-start'} >
                        <div className="px-3 py-2 rounded text-break alert alert-success w-100"
                            style={{
                                width: 'fit-content',
                                maxWidth: '100%'
                            }}>
                            {this.state.isCustomer ?
                                <FormattedMessage
                                    id="question.conversation.customer_default_message"
                                    defaultMessage="No question asked yet. You can ask a question to the seller now."
                                /> :
                                <FormattedMessage
                                    id="question.conversation.seller_default_message"
                                    defaultMessage="This customer hasn't asked any question yet, but you can still contact them first."
                                />}
                        </div>
                    </div>
                </li>
            }
        </ul>
    }
}

export default injectIntl(QuestionConversationContent)





// WEBPACK FOOTER //
// ./src/question-conversation/questionconversationcontent.jsx